window.theme = window.theme || {};
theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];
  $(document).on('shopify:section:load', this._onSectionLoad.bind(this)).on('shopify:section:unload', this._onSectionUnload.bind(this)).on('shopify:section:select', this._onSelect.bind(this)).on('shopify:section:deselect', this._onDeselect.bind(this)).on('shopify:block:select', this._onBlockSelect.bind(this)).on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = (instance.id === evt.detail.sectionId);

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

window.slate = window.slate || {};

/*** Currency Helpers */
theme.Currency = (function() {
  var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision || 2;
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';
      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }
    return formatString.replace(placeholderRegex, value);
  }
  return {
    formatMoney: formatMoney
  }
})();

/*================ SECTIONS ================*/
theme.Product = (function(){
    function Product(container){
        this.container = container;
        var $container = this.$container = $(container),
            sectionId = $container.attr('data-section-id'),
            activemedia = $("#MediaGallery-quick-view").data('target');
        const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-quick-view"]`);
        mediaGalleries.forEach((mediaGallery) => mediaGallery.setActiveMedia(`media${activemedia}`, true));
    }
    return Product;
})();

$(document).ready(function() {
  var sections = new theme.Sections();
  sections.register('quickView', theme.Product);
});

if (!customElements.get('quickview-media')){
    customElements.define('quickview-media', class MediaGallery extends HTMLElement {
        constructor(){
            super();
            this.setActiveMedia(this.dataset.target);
        }
        setActiveMedia(mediaId, prepend){
            var breakpoint = window.matchMedia('(min-width: 768px)'),
                prslider,
                sliderId = this.dataset.section,
                opt = $(this.dataset.section).attr("data-slider-options");

            if(opt){
                prslider = new Swiper (sliderId, JSON.parse(opt));
                prslider.on('slideChange', function(){
                    var videos = $('.swiper-slide video'),
                        slide = prslider.slides.eq(prslider.activeIndex),
                        video = $(slide).find('video').get(0);
                    Array.prototype.forEach.call(videos, function(v){ v.pause(); });
                    if($(video).length){ video.play(); }
                });
            }
            const activeMedia = $('.pr_photo:not(.swiper-slide-duplicate)[data-id="'+mediaId+'"]').attr('data-slide');
            if(activeMedia != undefined){
                prslider.slideToLoop(activeMedia);
            }
        }
    });
    
    
}
$(document).on('click', '.swatch', function(e) {  // Exact class match
  e.preventDefault();
  e.stopPropagation();
  
  var $card = $(this).closest('.grid__item, .product-card');  // Belle card
  var $quickShop = $card.find('.quickShop');  // Your button
  if (!$quickShop.length) return;
  
  var selectedColor = $(this).attr('title');  // "Berry" from title attr—exact match
  
  // Trigger existing Quick Shop
  $quickShop[0].click();
  
  // Pre-select in modal
  setTimeout(function() {
    var $modal = $('.quick-shop-modal, #quick-shop-modal, .modal-quick-view');  // Tune if needed
    if ($modal.length) {
      var $modalSwatch = $modal.find(`.swatch[title="${selectedColor}"], [title="${selectedColor}"], input[value="${selectedColor}"]`);
      if ($modalSwatch.length) {
        $modalSwatch.click();  // Filters sizes/widths to in-stock for "Berry"
        // Sync media if linked (from quickview.js)
        var mediaId = $modalSwatch.data('media-id') || '0';
        if (mediaId) {
          $modal.find('quickview-media').setActiveMedia(`media${mediaId}`, true);
        }
      }
    }
  }, 600);  // AJAX delay
  
  console.log('Quick Shop for color:', selectedColor);  // Debug
});
